import React from 'react';
import {observer} from 'mobx-react';
import {EmployeeNameWithAvatar} from 'shared/components';

const EmployeeNameCell = observer(({model}) => {
  return <EmployeeNameWithAvatar employee={model.employee}/>;
});

export default EmployeeNameCell;
